import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaBell, FaUserCircle, FaSearch } from 'react-icons/fa';
import './AdminHeader.css';

export const AdminHeader: React.FC = () => {
  const navigate = useNavigate();

  return (
    <header className="admin-header">
      <div className="admin-header__content">
        {/* Search Bar */}
        <div className="admin-header__search">
          <FaSearch className="admin-header__search-icon" />
          <input
            type="text"
            placeholder="Search..."
            className="admin-header__search-input"
          />
        </div>

        {/* Right Side Actions */}
        <div className="admin-header__actions">
          {/* Notifications */}
          <button 
            className="admin-header__action-btn" 
            aria-label="Notifications"
            onClick={() => navigate('/admin/notifications')}
          >
            <FaBell />
            <span className="admin-header__badge">3</span>
          </button>

          {/* User Profile */}
          <div className="admin-header__user">
            <button 
              className="admin-header__user-btn"
              onClick={() => navigate('/admin/profile')}
            >
              <FaUserCircle className="admin-header__user-icon" />
              <span className="admin-header__user-name">Admin</span>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};
